import { AnyAction } from 'redux';
import { ActionsProducer } from '../../Actions/Producer/Types';
import { Producer } from '../../Models/Report';

export interface IProducerState {
	isRequest: boolean;
	producers: Producer[];
}

const initialState = {
	isRequest: false,
	producers: [],
};

const asyncReducer = (
	state: IProducerState = initialState,
	action: AnyAction
) => {
	switch (action.type) {
		case ActionsProducer.REQUEST_PRODUCER:
			return {...state, isRequest: !state.isRequest };
		case ActionsProducer.FETCH_PRODUCERS:
			const producers = action.payload as Producer[];
			return {...state, producers };
	}
	return state;
};

export default asyncReducer;
